import React from "react";
import { PageLayout } from "../components/PageLayout";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import sg1 from '../images/schoolgroups/1.jpg';
import sg2 from '../images/schoolgroups/2.jpg';
import sg3 from '../images/schoolgroups/3.jpg';
import sg4 from '../images/schoolgroups/4.jpg';
import sg5 from '../images/schoolgroups/5.jpg';
import sg6 from '../images/schoolgroups/6.jpg';
import sg7 from '../images/schoolgroups/7.jpg';
import sg8 from '../images/schoolgroups/8.jpg';
import sg9 from '../images/schoolgroups/9.jpg';
import sg10 from '../images/schoolgroups/10.jpg';
import sg11 from '../images/schoolgroups/11.jpg';
import sg12 from '../images/schoolgroups/12.jpg';

import ContactCTA from "../components/ContactCTA";

const SchoolGroup = () => {
  document.title = "School Groups - Hampton Jitney Charters";
  return (
    <PageLayout>
      <div className="flex-grow overflow-y-scroll border border-black rounded-lg">
        <div className="border border-black rounded-lg p-4 mt-4 bg-white bg-opacity-75 mx-4">
          <h1 className="text-4xl font-bold mb-4 text-center">School Groups</h1>
          <div className="w-full lg:w-1/2">
            <p class="text-2xl text-gray-800 mb-8">
              Hampton Jitney offers premier coach rentals for extraordinary school trips.
            </p>
            <p class="text-lg font-semibold text-gray-800 mb-8">
              Our meticulously maintained coaches provide top-notch amenities, including spacious seating,
              air conditioning, onboard restrooms, and entertainment systems. With experienced staff to
              assist you, we ensure a perfect coach rental for your day trip or multi-day excursion.
              Safety is a priority with school-certified drivers and strict maintenance standards.
            </p>
            <ContactCTA
              heroImg={sg5}
              ctaText={"Organize transporation for your next School Outing today"}
              bodyText={"Contact us at 631-287-4000, or <a href='mailto:charter@hamptonjitney.com'>charter@hamptonjitney.com</a>."}
            />
          </div>
          <Carousel
            className="flex justify-between w-[60%] mt-4 mx-auto mt-20"
            showArrows={true}
            infiniteLoop={true}
            showThumbs={false}
            showStatus={false}

          >
            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg1} alt="ig1" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg2} alt="ig2" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg3} alt="ig4" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg4} alt="ig4" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg5} alt="ig5" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg6} alt="ig6" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg7} alt="ig7" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg8} alt="ig8" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg9} alt="ig9" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>
            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg10} alt="ig11" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>
            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg11} alt="ig11" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>
            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={sg12} alt="ig12" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

          </Carousel>
        </div>
      </div>
    </PageLayout>
  );
};

export default SchoolGroup;
